import api from "../utils/api";
import { Reporter } from "../common/models/CommonModels";

export const getReporters = (includeTrucks: boolean, includeUnits: boolean): Promise<Reporter[]> => {

    const include = `?includetrucks=${includeTrucks}&includeunits=${includeUnits}`

    return api.get("api/filters/reportedby" + include).then(response => {
        if (response.status === 200) {
            const data = <Reporter[]>response.data;
            return data;
        }
        return [];
    }).catch(error => {
        return []
    });
}


// WEBPACK FOOTER //
// ./src/api/filterValuesApi.ts